<template lang="html">
  <div class="soft-ware">
      <!-- banner -->
      <div class="banner-img">
          <!-- <img width="100%" src="https://static.qyjmed.com/webSite/productService/software/banner.png" alt=""> -->
          <div class="container">
              <div class="soft-img">
                  <div class="soft">
                      <img src="https://static.qyjmed.com/webSite/productService/software/soft1.png" alt="">
                      <p>实时监控</p>
                  </div>
                  <div class="soft">
                      <img src="https://static.qyjmed.com/webSite/productService/software/soft2.png" alt="">
                      <p>耗材管理</p>
                  </div>
                  <div class="soft">
                      <img src="https://static.qyjmed.com/webSite/productService/software/soft3.png" alt="">
                      <p>效益分析</p>
                  </div>
                  <div class="soft">
                      <img src="https://static.qyjmed.com/webSite/productService/software/soft4.png" alt="">
                      <p>工作提醒</p>
                  </div>
              </div>
          </div>
      </div>
      <!-- 下载app -->
      <div class="app">
        <div class="container">
          <img src="https://static.qyjmed.com/webSite/productService/software/iphone.png" alt="">
          <div class="app-text">
            <p class="app-title">全医佳助手</p>
            <p>利用信息化搭建与医院发展规模相适应、规范、优化工作流程并有效促进管理水平提升的“医疗设备管理平台”移动端</p>
            <!-- <button type="button" @mouseenter="ewm=true" @mouseleave="ewm=false" name="button">DOWNLOAD</button> -->
            <div class="ewm" v-show="ewm">
                <img src="https://static.qyjmed.com/webSite/productService/software/toApp.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 场景 -->
      <div class="scene">
          <div class="container">
              <h2>应用场景</h2>
              <p>application scenario</p>
              <ul>
                  <li>
                      <div class="scene-box">
                          <img src="https://static.qyjmed.com/webSite/productService/software/ware1.png" alt="">
                          <p>实时监控</p>
                          <div class="scene-content">
                              <p>对医院的大型设备运行状态进行远程监控：监控设备的开机率、开关机时间，扫描次数进行统计。对医院的中小型设备使用率进行统计，为医院是否购买新设备提供依据。</p>
                          </div>
                      </div>
                  </li>
                  <li>
                      <div class="scene-box">
                          <img src="https://static.qyjmed.com/webSite/productService/software/ware2.png" alt="">
                          <p>耗材管理</p>
                          <div class="scene-content">
                              <p>采购前的资格审核管理：必须持有医疗器械经营许可证、营业执照、医疗器械生产企业许可证、医疗器械注册证等。耗材的出入库管理：按照耗材类别对入库的耗材进行分类，同时进行操作。</p>
                          </div>
                      </div>
                  </li>
                  <li>
                      <div class="scene-box">
                          <img src="https://static.qyjmed.com/webSite/productService/software/ware3.png" alt="">
                          <p>效益分析</p>
                          <div class="scene-content">
                              <p>对医院大型设备进行收入，支出的分析，从而为医院的决策提供支持，进行统计，以及图形展示，并可按设备金额、科室、设备名称进行查询，并支持手工EXCEL导入和接口解决方案。</p>
                          </div>
                      </div>
                  </li>
                  <li>
                      <div class="scene-box">
                          <img src="https://static.qyjmed.com/webSite/productService/software/ware4.png" alt="">
                          <p>工作提醒</p>
                          <div class="scene-content">
                              <p>库存不足及有效期到期提醒、待维护设备提醒、待保养设备提醒、计量提醒、供应商合同到期提醒、三证到期提醒以及折旧到期提醒等。</p>
                          </div>
                      </div>
                  </li>
                  <li>
                      <div class="scene-box">
                          <img src="https://static.qyjmed.com/webSite/productService/software/ware5.png" alt="">
                          <p>资产管理</p>
                          <div class="scene-content">
                              <p>包含了设备资产卡片管理，设备条码管理，固定资产管理电子帐，设备折旧管理，固定资产转科管理，固定资产盘点清理，资产入库以及预备账户管理，灵活自由的资产查询，固定资产报废管理，公共设备平台，数据备份，导入，导出功能。</p>
                          </div>
                      </div>
                  </li>
                  <li>
                      <div class="scene-box">
                          <img src="https://static.qyjmed.com/webSite/productService/software/ware6.png" alt="">
                          <p>保养管理</p>
                          <div class="scene-content">
                              <p>医院设备器械数量多，品类杂的现状，无疑增加了医院设备维护的难度和各种问题。设备维修管理仅用人工EXCEL表格管理，显然不能实现高效查询统计的需要，不能适应现代化医院发展的需要。而采取信息化管理，借助软件管理进行保养设置，按照设备类别进行精确保养管理，才是当下医院最明智的选择。</p>
                          </div>
                      </div>
                  </li>
                  <li>
                      <div class="scene-box">
                          <img src="https://static.qyjmed.com/webSite/productService/software/ware7.png" alt="">
                          <p>质量控制</p>
                          <div class="scene-content">
                              <p>随着医疗改革的不断深入，医院为了提高自身的医疗技术水平，纷纷购置各种医疗仪器设备，特别是具有世界先进水平的大型医疗仪器设备来装备医院。医疗设备质量的稳定性也成为医院医疗整体质量的一个重要因素，直接影响到病人安全，治疗效果及医院的经济效益。因此，有必要建立和完善医疗设备质量控制体系。</p>
                          </div>
                      </div>
                  </li>
                  <li>
                      <div class="scene-box">
                          <img src="https://static.qyjmed.com/webSite/productService/software/ware8.png" alt="">
                          <p>工作流程</p>
                          <div class="scene-content">
                              <p>所有涉及审批流程的资产操作均由同一入口一工作流程实现，在工作流程进行新的流程发起或是对现有流程进行审批操作，避免了传统管理软件多入口，操作复杂的情形，使得用户能简单上手，便捷的使用设备管理软件。</p>
                          </div>
                      </div>
                  </li>
              </ul>
          </div>
      </div>
      <!-- 荣誉证书 -->
      <div class="honor">
          <div class="container">
              <h2>荣誉证书</h2>
              <p>Honorary certificate</p>
          </div>
      </div>
      <div class="three-d">
          <div class="container">
              <!-- swiper -->
              <swiper :options="swiperOption">
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/1.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/2.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/3.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/T19001.jpg"></swiper-slide>
                <swiper-slide style="width:530px"><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/gaoxin.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/4.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/5.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0018.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0019.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0023.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0044.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0045.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0115.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0118.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0119.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0120.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0122.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0123.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0080.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0081.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0083.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0084.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/202004260501_0091.jpg"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/01.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/02.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/03.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/04.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/05.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/06.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/07.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/08.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/09.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/10.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/11.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/12.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/13.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/14.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/15.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/16.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/17.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/18.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/19.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/20.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/21.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/22.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/23.png"></swiper-slide>
                <swiper-slide><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/24.png"></swiper-slide>
                <swiper-slide style="width:530px"><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/6.png"></swiper-slide>
                <swiper-slide style="width:530px"><img width="100%" src="https://static.qyjmed.com/webSite/productService/software/cert/7.png"></swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
          </div>
      </div>
      <Foot></Foot>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import {
	swiper,
	swiperSlide
} from 'vue-awesome-swiper';
import Foot from '@/components/Footer.vue'
export default {
	name: 'software',
	data() {
		return {
			swiperOption: {
				effect: 'coverflow',
				grabCursor: true,
				// autoplay:3000,
				initialSlide: 4,
				centeredSlides: true,
				slidesPerView: 'auto',
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: true
				},
				pagination: {
					el: '.swiper-pagination'
				}
			},
			ewm: true
		}
	},
	components: {
		swiper,
		swiperSlide,
		Foot
	}
}
</script>

<style lang="scss" scoped>
.swiper-inner {
    width: 100%;
    height: 400px;
    padding-top: 50px;
    padding-bottom: 50px;
}
.swiper-slide {
    background-position: center;
    background-size: cover;
    width: 300px;
    height: 400px;
}
.soft-ware {
    .banner-img {
        background: url("https://static.qyjmed.com/webSite/productService/software/banner.png") center;
        height: 562px;
        margin-top: $highlight-height;
        position: relative;
        .container {
            .soft-img {
                position: absolute;
                bottom: 30px;
                .soft {
                    width: 300px;
                    height: 80px;
                    display: inline-block;
                    border-left: 2px solid #ffffff44;
                    img {
                        vertical-align: text-bottom;
                        padding-left: 50px;
                    }
                    p {
                        display: inline-block;
                        font-size: 18px;
                        color: white;
                        height: 80px;
                        margin-left: 34px;
                        vertical-align: middle;
                    }
                    &:last-child {
                        border-right: 2px solid #ffffff44;
                    }
                }
            }
        }
    }
    // app
    .app {
        background: url("https://static.qyjmed.com/webSite/productService/software/bj.png") no-repeat center;
        height: 600px;
        .container {
            > img {
                margin-top: 57px;
            }
            .app-text {
                display: inline-block;
                vertical-align: top;
                text-align: center;
                width: 655px;
                margin: 160px 90px 0;
                p {
                    font-size: 20px;
                    color: #606060;
                    line-height: 40px;
                    margin-bottom: 56px;
                    &.app-title {
                        font-size: 40px;
                        color: #1B212B;
                        margin-bottom: 40px;
                    }
                }
                button {
                    width: 250px;
                    height: 70px;
                    line-height: 70px;
                    color: white;
                    font-size: 24px;
                    background: linear-gradient(to right,#58D2E7, #6D98F6);
                    border-radius: 35px;
                    border: 0;
                    cursor: pointer;
                }
                .ewm {
                    img {
                        width: 150px;
                    }
                }
            }
        }
    }
    // 场景
    .scene {
        .container {
            > h2 {
                font-size: 30px;
                margin-top: 56px;
                text-align: center;
            }
            > p {
                margin: 18px 0 6px;
                text-align: center;
                color: #6A6A6A;
            }
            ul {
                li {
                    width: 380px;
                    display: inline-block;
                    vertical-align: top;
                    margin-right: 30px;
                    &:nth-child(3n+3) {
                        margin-right: 0;
                    }
                    div.scene-box {
                        margin-top: 40px;
                        > img {
                            position: relative;
                        }
                        > p {
                            position: absolute;
                            margin-top: -65px;
                            color: white;
                            margin-left: 34px;
                            font-size: 24px;
                        }
                        div {
                            background-color: #F6F8FA;
                            width: 378px;
                            height: 190px;
                            margin-top: -4px;
                            border-bottom-right-radius: 6px;
                            border-bottom-left-radius: 6px;
                            p {
                                font-size: 14px;
                                line-height: 26px;
                                padding: 20px 20px 0;
                            }
                        }
                    }
                }
            }
        }
    }
    // 荣誉证书
    .honor {
        margin-top: 26px;
        background: url("https://static.qyjmed.com/webSite/productService/software/honor.png");
        height: 300px;
        .container {
            text-align: center;
            color: white;
            h2 {
                font-size: 40px;
                padding: 132px 0 24px;
            }
            p {
                font-size: 24px;
            }
        }
    }
    // 轮播
    .three-d {
        .container {
            padding: 100px;
        }
    }
}
</style>
